import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	TestabilityRegistry,
	Input,
	Output,
	EventEmitter
} from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "../../../services/global/global.service";
import { Observable } from "rxjs";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { RegistrationRequest } from "src/app/models/dmv/registration.request";

import { Cart } from "src/app/models/dmv/cart";
import { DmvRegistrationManual } from "src/app/models/dmv/dmvRegistrationManual";
import { RouteFrom } from "../../../models/routeFrom";
import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { AppUtil } from "../../../utils/app.util";
import { DmvRegistration } from "src/app/models/dmv/dmvRegistration";
import { DmvRegistrationDuplicate } from "src/app/models/dmv/dmvRegistrationDuplicate";

@Component({
	selector: "dmv-shoping-cart",
	templateUrl: "./shoping-cart.component.html",
	styleUrls: ["./shoping-cart.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShopingCartComponent implements OnInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService
	) {}

	@Output() public clickEvent: EventEmitter<any> = new EventEmitter();
	public itemCount: number;
	//public donation: number;
	public _registrationsInCart;
	public dmvRegistrationsManual: Array<DmvRegistrationManual>;
	public agencyConfig: AgencyDmvConfigResponse;
	@Input("registrationsInCart")
	set registrationsInCart(value) {
		this._registrationsInCart = value;

		this.updateTotal();
	}

	@Input("donation")
	set donation(value) {
		this.updateTotal();
	}

	@Input("registrationsManual")
	set registrationsManual(value) {
		this.dmvRegistrationsManual = value;
		this.updateTotal();
	}
	public total: number;
	ngOnInit() {
		AppUtil.log("ShopingCartComponent ngOnInit()");
	}
	// public cost(registration){
	// 	let costAmount=0;
	// 	if(registration.renewalCost){
	// 		costAmount = costAmount+registration.renewalCost;
	// 	}
	// 	if(registration.plateStyleCost){
	// 		costAmount = costAmount+registration.plateStyleCost;
	// 	}
	// 	let dmvFees=0;
	// 	if(registration.dmvFees && registration.dmvFees.length>0){

	// 		registration.dmvFees.forEach(dmvFee => {

	// 			dmvFees = dmvFees+dmvFee.amount;

	// 		});

	// 		costAmount = costAmount+dmvFees;
	// 	}
	// 	registration.otherFees=dmvFees;
	// 	registration.totalAmountDue=costAmount;
	// 	return costAmount;
	// }
	public updateTotal() {
		AppUtil.log("ShopingCartComponent updateTotal()");
		this.dmvStoreService.agencyConfig$.subscribe(agencyConfig => {
			if (agencyConfig) {
				this.agencyConfig = agencyConfig;
			}
		});
		let total: number = 0;
		const totalAmountDue = 0;
		this.itemCount = 0;
		if (this._registrationsInCart) {
			this.itemCount = this._registrationsInCart.length;
		}
		if (this.dmvStoreService.registrationsInCart.donation) {
			this.itemCount = this.itemCount + 1;
		}
		if (this.dmvStoreService.registrationsInCart.dmvRegistrationsManual) {
			this.itemCount =
				this.itemCount +
				this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.length;
		}
		if (this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate) {
			this.itemCount =
				this.itemCount +
				this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate
					.length;
		}

		if (this._registrationsInCart) {
			this.globalService.cartNature = "search";
			this._registrationsInCart.forEach((dmvRegistration: DmvRegistration) => {
				let costAmount = 0;
				if (dmvRegistration.registration.renewalCost) {
					costAmount = costAmount + dmvRegistration.registration.renewalCost;
				}
				let plateStyleCost = 0;
				let plateStyleNetChange = 0;
				let otherFees = 0;
				let plateStyleProcessingCost = 0;
				let plateStyleRepLacementFee = 0;
				if (
					dmvRegistration.registration.dmvFees &&
					dmvRegistration.registration.dmvFees.length > 0
				) {
					dmvRegistration.registration.dmvFees.forEach(dmvFee => {
						if (
							dmvFee.feeID !== 7 &&
							dmvFee.feeID !== 8 &&
							dmvFee.feeID !== 4
						) {
							if (dmvFee.feeID === 1) {
								if (
									this.agencyConfig.agencyDmvConfig.mailFeeModel !== "NEVER"
								) {
									if (
										this.agencyConfig.agencyDmvConfig.mailFeeModel === "ALWAYS"
									) {
										otherFees = otherFees + dmvFee.amount;
									} else if (
										this.agencyConfig.agencyDmvConfig.mailFeeModel ===
											"MAILONLY" &&
										this.dmvStoreService.registrationsInCart.mailingAddress
									) {
										otherFees = otherFees;
									}
								}
							} else {
								otherFees = otherFees + dmvFee.amount;
							}
						}

						if (dmvFee.feeID === 4) {
							plateStyleCost = plateStyleCost + dmvFee.amount;
							plateStyleRepLacementFee = dmvFee.amount;
						}
						if (dmvFee.feeID === 7) {
							plateStyleCost = plateStyleCost + dmvFee.amount;
							plateStyleNetChange = dmvFee.amount;
						}
						if (dmvFee.feeID === 8) {
							plateStyleCost = plateStyleCost + dmvFee.amount;
							plateStyleProcessingCost = dmvFee.amount;
						}
						// if (dmvFee.feeID === 7 || dmvFee.feeID === 8) {
						// 	plateStyleCost = plateStyleCost + dmvFee.amount;
						// 	plateStyleNetChange = plateStyleNetChange + dmvFee.amount;
						// }
						// if (dmvFee.feeID === 4) {
						// 	plateStyleProcessingCost = dmvFee.amount;
						// 	plateStyleCost = plateStyleCost + dmvFee.amount;
						// }
					});

					costAmount = costAmount + otherFees + plateStyleCost;
				}
				dmvRegistration.plateStyleCost = plateStyleCost;
				dmvRegistration.newPlateStyleCost = plateStyleCost;
				dmvRegistration.plateStyleNetChange = plateStyleNetChange;
				dmvRegistration.plateStyleRepLacementFee = plateStyleRepLacementFee;
				dmvRegistration.plateStyleProcessingCost = plateStyleProcessingCost;
				dmvRegistration.otherFees = otherFees;
				dmvRegistration.registration.totalAmountDue = costAmount
					? Number(costAmount.toFixed(2))
					: costAmount;

				total += dmvRegistration.registration.totalAmountDue;
			});
		}

		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual &&
			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.length > 0
		) {
			if (!this._registrationsInCart) {
				this.globalService.cartNature = "manual";
			}
			this.dmvStoreService.registrationsInCart.dmvRegistrationsManual.forEach(
				dmvRegistrationManual => {
					total += dmvRegistrationManual.amount + dmvRegistrationManual.lateFee;
				}
			);
		}
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate &&
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate
				.length > 0
		) {
			if (!this._registrationsInCart) {
				this.globalService.cartNature = "manual";
			}
			this.dmvStoreService.registrationsInCart.dmvRegistrationsDuplicate.forEach(
				(item: DmvRegistrationDuplicate) => {
					total = total + item.dmvCostData.totalAmountDue;
				}
			);
		}
		if (!this.agencyConfig.agencyDmvConfig.homogeneousCart) {
			this.globalService.cartNature = "TBD";
		}

		this.total =
			total +
			(this.dmvStoreService.registrationsInCart &&
			this.dmvStoreService.registrationsInCart.donation
				? this.dmvStoreService.registrationsInCart.donation.amount
				: 0);

		AppUtil.log("ShopingCartComponent updateTotal() ==> total", total);
	}

	public editRegistration(page, event) {
		AppUtil.log(
			"ShopingCartComponent editRegistration() ==> page, event",
			page,
			event
		);
		const routeFrom: RouteFrom = Object.create(null);
		this.dmvStoreService.routeFrom = routeFrom;
		this.dmvStoreService.routeFrom.from = "shoping-cart";
		this.dmvStoreService.routeFrom.orderNumber = page;
		this.clickEvent.emit(page);
		this.router.navigate(["dmv-customize-order"], {
			skipLocationChange: true
		});
	}
	public editManualRenew(page, event) {
		AppUtil.log(
			"ShopingCartComponent editManualRenew() ==> page, event",
			page,
			event
		);
		const routeFrom: RouteFrom = Object.create(null);
		this.dmvStoreService.routeFrom = routeFrom;
		this.dmvStoreService.routeFrom.from = "shoping-cart";
		this.dmvStoreService.routeFrom.orderNumber = page;
		this.clickEvent.emit(page);
		this.router.navigate(["dmv-manual-renew"], {
			skipLocationChange: true
		});
	}
	public editDuplicateRenew(page, event) {
		AppUtil.log(
			"ShopingCartComponent editDuplicateRenew() ==> page, event",
			page,
			event
		);
		const routeFrom: RouteFrom = Object.create(null);
		this.dmvStoreService.routeFrom = routeFrom;
		this.dmvStoreService.routeFrom.from = "shoping-cart";
		this.dmvStoreService.routeFrom.orderNumber = page;
		this.clickEvent.emit(page);
		this.router.navigate(["dmv-duplicate"], {
			skipLocationChange: true
		});
	}

	public editDonation(event) {
		AppUtil.log("ShopingCartComponent editDonation() ==> event", event);
		const routeFrom: RouteFrom = Object.create(null);
		this.dmvStoreService.routeFrom = routeFrom;
		this.dmvStoreService.routeFrom.from = "shoping-cart";
		this.dmvStoreService.routeFrom.orderNumber = null;
		this.router.navigate(["dmv-donation"], {
			skipLocationChange: true
		});
	}
}
